import { ICheckoutModel, TrackingRequest, TrackingRequestType } from "@/models";
import { getFacebookCookieValue } from "@/helpers";

/**
 * Gets a tracking request for POST api/Tracking/{type}
 * @param type the request type
 * @param checkout the checkout model
 * @param orderId the order id
 * @param currentUrl the URL of the event
 */
export function getTrackingRequest(
    type: TrackingRequestType,
    checkout: ICheckoutModel,
    orderId: string,
    currentUrl: string
): TrackingRequest {
    return {
        type: type,
        tracking: {
            promotionId: checkout.promotionId,
            email: checkout.email,
            emailOptIn: checkout.emailOptIn,
            promotionCode: checkout.promotionCode,
            cjEvent: checkout.cjEvent,
            facebookClickId: checkout.facebookClickId,
            facebookFbpCookieValue: getFacebookCookieValue("_fbp"),
            facebookFbcCookieValue: getFacebookCookieValue("_fbc"),
            orderId: orderId,
            eventSourceUrl: currentUrl
        }
    };
}
